import { render, staticRenderFns } from "./CategoriesFilters.vue?vue&type=template&id=a6264238&"
import script from "./CategoriesFilters.vue?vue&type=script&lang=js&"
export * from "./CategoriesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports